import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "react-bootstrap";
import { Formik } from 'formik';
import TaskTable from 'src/components/add-task/TaskTable';
import TodayTasks from 'src/components/add-task/TodayTasks';
import CombinedTasks from 'src/components/add-task/CombinedTasks';
import DeleteModal from 'src/components/add-task/DeleteModal';
import HierarchyModal from 'src/components/add-task/HierarchyModal';
import TaskForm from 'src/components/add-task/TaskForm';
import { ScheduleTaskDefaultProps, ScheduleTaskYupSchema, tasksList } from './ScheduleTaskPropTypes';
import ScheduleTaskFilter from './ScheduleTaskFilter';
import { useDispatch } from 'react-redux';
import { scheduleResetAction, scheduleSearchAction, scheduleUpsertAction, taskEditAction } from './actions/ScheduleTaskActions';
import { useEffect } from 'react';
import { scheduleSubTaskDeleteAPI } from 'src/api/ScheduleTaskApi';


const ScheduleTaskContainer = () => {
    const [tasks, setTasks] = useState(tasksList);
    const [activeTab, setActiveTab] = useState("all");
    const [search, setSearch] = useState("");
    const [assignee, setAssignee] = useState("");
    const [taskId, setTaskId] = useState(null);
    const dispatch = useDispatch();

    const [showModal, setShowModal] = useState(false);
    const [editTask, setEditTask] = useState(null);
    const [taskToDelete, setTaskToDelete] = useState(null);
    const [showHierarchyModal, setShowHierarchyModal] = useState(false);
    const [where, setWhere] = useState({});
    const [defaultTaskSchedule, setDefaultTaskSchedule] = useState(ScheduleTaskDefaultProps);
    const [todayTasks, setTodayTasks] = useState([]);
    const [editSelectedTask, setEditSelectedTask] = useState(null);

    const filtered = tasks.filter(task =>
        (task.task.toLowerCase().includes(search.toLowerCase()) ||
            task.subtask.toLowerCase().includes(search.toLowerCase())) &&
        (assignee ? task.assignedTo === assignee : true)
    );

    const onSubmit = useCallback(async (values, { resetForm, setFieldValue }) => {
        // ({ setSubmitting } = formikUtils);
        // convert users to ids in side subtasks array users array
        const payload = values.subTasks.map((subtask) => ({
            ...subtask,
            users: subtask.assignTo === "Other" ? subtask.users.map((user) => user.id) : [],
        }))
        // values.users = users;
        dispatch(scheduleUpsertAction({ ...values, subTasks: payload }));
        resetForm();
        setShowModal(false)
    }, [
        dispatch,
    ]);
    const editClick = useCallback((data, record) => {
        // if (departmentEditAction) {
        //     dispatch(departmentEditAction(record));
        // }
        // else {
        // find all the subtasks of this taskId._id order by created date
        setEditSelectedTask(record._id);
        const subTasks = data.filter((task) => task.taskId._id === record.taskId._id).sort((a, b) => new Date(a.ts) - new Date(b.ts)).map((task) => ({
            subTaskName: task.subTaskName,
            assignTo: task.assignTo,
            users: task.users.map((user) => ({
                id: user._id,
                value: `${user.firstName} ${user.lastName} (${user.employeeID})`,//
                label: `${user.firstName} ${user.lastName} (${user.employeeID})`//
            })) || [],
            frequency: task.frequency,
            selectedDays: task.selectedDays,
            selectedMonthDates: task.selectedMonthDates,
            startDate: "",
            initiationType: task.initiationType,
            time: task.time,
            duration: task.duration,
            durationUnit: task.durationUnit,
            _id: task._id
        }));
        const deletePayload = {
            taskName: record.taskName || record.taskId.taskName,
            subTasks: subTasks,
            // subTasks: [
            //     {
            //         subTaskName: record.subTaskName,
            //         assignTo: record.assignTo,
            //         users: record?.users?.map((user) => ({
            //             id: user._id,
            //             value: `${user.firstName} ${user.lastName} `,//(${user.employeeID})
            //             label: `${user.firstName} ${user.lastName} `//(${user.employeeID})
            //         })) || [],
            //         frequency: record.frequency,
            //         selectedDays: record.selectedDays,
            //         startDate: "",
            //         initiationType: record.initiationType,
            //         time: record.time,
            //         duration: record.duration,
            //         durationUnit: record.durationUnit,
            //         _id: record._id
            //     }
            // ],
            _id: record.taskId._id
        }
        setDefaultTaskSchedule(deletePayload)
        dispatch(taskEditAction({ data: deletePayload }));
        // }
    }, [
        dispatch,
    ]);
    useEffect(() => {
        handleSearch(where);
    }, [
        dispatch,
        where
    ]);
    const handleSearch = useCallback(() => {
        dispatch(scheduleSearchAction({
            where: where,
        }));
    }, [dispatch, where])

    const handleDelete = async (subTaskId) => {
        await scheduleSubTaskDeleteAPI({ scheduleSubTaskId: subTaskId });
        handleSearch();
        setTaskToDelete(null);
    };
    const openAddTaskModal = () => {
        setShowModal(true);
        setEditSelectedTask(null);
        setDefaultTaskSchedule(ScheduleTaskDefaultProps);
        dispatch(scheduleResetAction());
    };
    const handleClose = () => {
        setShowModal(false);
        setEditSelectedTask(null);
        setDefaultTaskSchedule(ScheduleTaskDefaultProps);
        dispatch(scheduleResetAction());
    };
    return (
        <div className="mt-4">
            <div className="row">
                <div className="col-xxl-12 col-xl-12">
                    <div className="card h-100">
                        <div className="card-body p-24">
                            {/* Header */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h2 className="fw-semibold mb-0 d-flex align-items-center gap-4 font-24">TaskBoard</h2>
                                    <small className="text-muted">Manage your daily tasks</small>
                                </div>
                                {/* <button className="btn btn-primary" onClick={() => { setEditTask(null); setShowModal(true); }}>
                  + Add Task
                </button> */}
                                <Button variant="primary" onClick={openAddTaskModal}>
                                    + Add Task
                                </Button>
                            </div>

                            {/* Custom Tabs */}
                            <div className="TaskBoardTabs mb-3">
                                <nav className="tabs">
                                    <ul className="-primary nav my-16 justify-content-start">
                                        <li className={`${activeTab === "all" ? "active" : ""} me-3`}>
                                            <button className="btn btn-link p-0 text-decoration-none" onClick={() => { setAssignee(""); setActiveTab("all") }}>
                                                All Tasks
                                            </button>
                                        </li>
                                        {/* <li className={`${activeTab === "today" ? "active" : ""} me-3`}>
                                            <button className="btn btn-link p-0 text-decoration-none" onClick={() => { setAssignee(""); setActiveTab("today") }}>
                                                Today’s Task
                                            </button>
                                        </li> */}
                                        <li className={`${activeTab === "combined" ? "active" : ""}`}>
                                            <button className="btn btn-link p-0 text-decoration-none" onClick={() => { setAssignee(""); setActiveTab("combined") }}>
                                                Hierarchy + Fixed
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                            {/* Filters */}
                            {/* {activeTab === "all" && ( */}
                            <ScheduleTaskFilter
                                activeTab={activeTab}
                                search={search}
                                setSearch={setSearch}
                                assignee={assignee}
                                setAssignee={setAssignee}
                                setShowHierarchyModal={setShowHierarchyModal}
                                setTaskId={setTaskId}
                                taskId={taskId}
                            />
                            {/* )} */}

                            {/* Task Table / Today's / Combined */}
                            {activeTab === "all" && (
                                <TaskTable
                                    tasks={filtered}
                                    filterSearch={search}
                                    assignee={assignee}
                                    taskId={taskId}
                                    onEdit={
                                        (data, task) => {
                                            editClick(data, task);
                                            setShowModal(true);
                                        }
                                    }//setEditTask(task);
                                    onDelete={(task) => setTaskToDelete(task)}
                                />
                            )}
                            {/* {activeTab === "today" && <TodayTasks handleSearch={handleSearch} assignee={assignee} />} */}
                            {activeTab === "combined" && <CombinedTasks
                                filterSearch={search}
                                tasks={[...tasks, ...todayTasks]}
                                assignee={assignee}
                                taskId={taskId}
                                handleSearch={handleSearch}
                                onDelete={(task) => setTaskToDelete(task)}
                                onEdit={
                                    (data, task) => {
                                        editClick(data, task);
                                        setShowModal(true);
                                    }
                                }
                            />}
                            {taskToDelete && (
                                <DeleteModal
                                    onClose={() => setTaskToDelete(null)}
                                    onConfirm={() => handleDelete((taskToDelete._id || taskToDelete.subTaskId))}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Hierarchy Modal */}
            <HierarchyModal
                handleSearch={handleSearch}
                show={showHierarchyModal}
                onHide={() => setShowHierarchyModal(false)}
            />
            {
                showModal && (
                    <Formik
                        initialValues={defaultTaskSchedule}
                        validationSchema={ScheduleTaskYupSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {(formikProps) => (
                            <TaskForm
                                show={showModal}
                                handleClose={handleClose}
                                editSelectedTask={editSelectedTask}
                                {...formikProps}
                            />
                        )}
                    </Formik>
                )
            }

            {/* <TaskForm show={showModal} handleClose={() => setShowModal(false)} /> */}
        </div>
    )
}
export default ScheduleTaskContainer